import { createSlice } from '@reduxjs/toolkit';
import { getLanguage } from '../libs/language';
import { getDBConection } from '../libs/firebaseApi';
import { ref, get } from 'firebase/database';
import { setCookieForm, deleteCookieForm } from '../libs/cookieManager';

export const siteSlice = createSlice({
  name: 'site',
  initialState: {
    items: [],
    user: undefined,
    language: getLanguage(),
    qp: '',
  },
  reducers: {
    setQP: (state, action) => {
      let qp = action.payload;

      return {
        ...state,
        qp: qp,
      };
    },
    setItems: (state, action) => {
      let newItems = action.payload ? action.payload : [];
      return { ...state, items: newItems };
    },
    setUserGenesis: (state, action) => {
      return state;
    },
    setConfigurationFetched: (state, action) => {
      let config = action.payload;
    
      let lan = getLanguage();

      if (lan === 'en-US') {

        config.contenido = config.contenido.en;
        
      } else {
        config.contenido = config.contenido.es;
      }
      return {
        ...state,
        configuration: { ...config, language: lan },
      };
    },
    initConfig: (state, action) => {
      return {
        ...state,
        initialConfig: action.payload,
        user: null,
      };
    },
    fetchUser: (state, action)=>{
      console.log("fetchUser");

      if (localStorage.getItem('user') === "null" || localStorage.getItem('user') === null) {
        console.log("No se ha encontrado ningún usuario en localStorage.");
        return {
            ...state,
        };
    } else {
        const user = localStorage.getItem('user');
        console.log("Usuario encontrado en localStorage:", user);
        
        try {
            // Decodificando y parseando el usuario desde Base64
            let user1 = JSON.parse(window.atob(user));
            console.log("Usuario decodificado:", user1);
            
            return {
                ...state,
                user: user1,
            };
        } catch (error) {
            console.error("Error al decodificar el usuario desde localStorage:", error);
            return {
                ...state,
            };
        }
    }
    
    },
    setUserFromGenesis: (state, action) => {
      //guardamos el token en un cookie
      
      setCookieForm('user', action.payload.userToken, getLanguage());
      //guardamos el user con el token en localstorage para evitar la llamada en cada recarga
      
      localStorage.setItem('user', window.btoa(JSON.stringify(action.payload)));
      //seteamos el nuevo state de la aplicacion
      return {
        ...state,
        user: action.payload,
      };
    },
    logoutUser: (state, action) => {
      deleteCookieForm('user', getLanguage());
      localStorage.setItem('user', null);
      return {
        ...state,
        user: undefined,
      };
    },
  },
});

export const fetchConfiguration = (site) => async (dispatch) => {
  get(ref(getDBConection(), '/configuration/' + site))
    .then((snapshot) => {
      const data = snapshot.val();
      dispatch(setConfigurationFetched(data));
    })
    .catch((error) => {
      console.error(error);
    });
};

export const setUserFromGenesisAsync = (user) => async (dispatch, getState) => {
  if (
    localStorage.getItem('user') &&
    localStorage.getItem('user') !== '' &&
    localStorage.getItem('user') !== null &&
    localStorage.getItem('user') !== 'null'
  ) {
    let User =JSON.parse( window.atob(localStorage.getItem('user')));
    
    
    if (User.userToken === user) {
      // llamamos a genesis si el usario no esta en localstorage
      dispatch(setUserFromGenesis({ ...User, userToken: user }));
    }
  }

  // "loginUser": "2leJvJJFkiQ=",
  // "loginPassword": "nlzufEFcsxzn5xsb6HFtGA==",
  let url = `${getState().site.initialConfig.urlLogin}?strUserName=2leJvJJFkiQ=&strPassword=nlzufEFcsxzn5xsb6HFtGA==&strToken=${user}`;


  try {
    let response = await fetch(url);
    if (response.ok) {  // Verifica si la solicitud fue exitosa


     
      let text = await response.text();  //  como texto
      let parser = new DOMParser();  // la instancia 
      let xmlDoc = parser.parseFromString(text, "application/xml");  // Parsear 
  
      // Acceder a los datos dentro del XML y verificamos que el result sea 1
      let intResult = xmlDoc.querySelector("intResult").textContent;
      let strResult = xmlDoc.querySelector("strResult").textContent; 
        if(intResult==="1")
        {
          console.log("strResult:", strResult); 
         // let pkPeopleID = xmlDoc.querySelector("pkPeopleID").textContent;  
          let pkPeopleID = xmlDoc.querySelector("pkPeopleID").textContent.length > 0
            ?  xmlDoc.querySelector("pkPeopleID").textContent : '';
          let FName = xmlDoc.querySelector("FName").textContent; 
          //let MName = xmlDoc.querySelector("MName").textContent; 
          let MName = xmlDoc.querySelector("MName").textContent.length > 0
              ? xmlDoc.querySelector("MName").textContent : '';
          let LName1 =xmlDoc.querySelector("LName1").textContent.length > 0
              ?  xmlDoc.querySelector("LName1").textContent: '';
          let LName2 = xmlDoc.querySelector("LName1").textContent.length > 0
                ? xmlDoc.querySelector("LName1").textContent : '';
          let fullName = xmlDoc.querySelector("fullName").textContent.length > 0
              ? xmlDoc.querySelector("fullName").textContent : '';
          let GuestType = xmlDoc.querySelector("GuestType").textContent.length > 0
              ? xmlDoc.querySelector("GuestType").textContent : '';
          let Email = xmlDoc.querySelector("Email").textContent.length > 0
              ? xmlDoc.querySelector("Email").textContent : '';
          let UserObject = {
                pkPeopleID,
                FName,
                MName,
                LName1,
                LName2,
                fullName,
                GuestType,
                Email,
              };
           
          dispatch(setUserFromGenesis({ ...UserObject, userToken: user }));
          //Fetichng the user´s last purchases [START]
      
       
        
        }
      

      } 
      
      else {
        console.error("Error en la solicitud:", response.status);  // Maneja errores si la solicitud falla
      }
  

    //window.xmlDoc = xmlDoc;
    
   /* if (xmlDoc.getElementsByTagName('intResult')[0]) {

   
      
      if (xmlDoc.getElementsByTagName('intResult')[0].childNodes[0]) {
        if (
          parseInt(
            xmlDoc.getElementsByTagName('intResult')[0].childNodes[0].nodeValue
          ) === 1
        ) {
          let pkPeopleID =
            xmlDoc.getElementsByTagName('pkPeopleID')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('pkPeopleID')[0].childNodes[0]
                  .nodeValue
              : '';
          let FName =
            xmlDoc.getElementsByTagName('FName')[0].childNodes[0].nodeValue;
          let MName =
            xmlDoc.getElementsByTagName('MName')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('MName')[0].childNodes[0].nodeValue
              : '';
          let LName1 =
            xmlDoc.getElementsByTagName('LName1')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('LName1')[0].childNodes[0].nodeValue
              : '';
          let LName2 =
            xmlDoc.getElementsByTagName('LName2')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('LName2')[0].childNodes[0].nodeValue
              : '';

          let fullName =
            xmlDoc.getElementsByTagName('fullName')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('fullName')[0].childNodes[0]
                  .nodeValue
              : '';
          let GuestType =
            xmlDoc.getElementsByTagName('GuestType')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('GuestType')[0].childNodes[0]
                  .nodeValue
              : '';
          let Email =
            xmlDoc.getElementsByTagName('Email')[0].childNodes.length > 0
              ? xmlDoc.getElementsByTagName('Email')[0].childNodes[0].nodeValue
              : '';
          let UserObject = {
            pkPeopleID,
            FName,
            MName,
            LName1,
            LName2,
            fullName,
            GuestType,
            Email,
          };

          dispatch(setUserFromGenesis({ ...UserObject, userToken: user }));

          //Fetichng the user´s last purchases [START]
          let urlShoppingHistory = `${getState().site.initialConfig.urlAPI}/${
            getState().site.initialConfig.WebSection
          }/Shopping/getItemRelated?iPeopleID=${pkPeopleID}`;
          let lastPurchases = await fetch(urlShoppingHistory);
          let purchasesResponse = lastPurchases.data;
          let newUser = { ...UserObject, itemsHistory: purchasesResponse };
          dispatch(setUserFromGenesis({ ...newUser, userToken: user }));
          //Fetichng the user´s last purchases [FINAL]
        }
      }
    }*/
  } catch (error) {
    dispatch(setUserFromGenesis({ data: error, user: user }));
  }
};

export const {
  setItems,
  setConfigurationFetched,
  initConfig,
  setUserFromGenesis,
  logoutUser,
  setQP,
  fetchUser,
} = siteSlice.actions;

// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectItems = (state) => state.site.items;

export default siteSlice.reducer;
